import { Component } from '@angular/core';
import { AuthenticationService } from '@datev/ngx-dcal';
import { DacklSectionMessageComponent } from '@datev/ngx-dackl';
import { TargetBlankDirective } from '../../../../../commons/src/lib/directive/target-blank.directive';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dp-logged-out-state',
    templateUrl: './logged-out-state.component.html',
    imports: [
        DacklSectionMessageComponent,
        TargetBlankDirective,
        MatButton,
    ],
})
export class LoggedOutStateComponent {
  constructor(private readonly authService: AuthenticationService) {}

  public login(): void {
    this.authService.login().catch(() => console.log('Login error'));
  }
}
